module.exports = "<div class=\"logo-parent\">\n  <h1>Landmarq</h1>\n  <p>Road</p>\n</div>"